import Diplomas from "./Diplomas"
export default Diplomas
